import { Cookies } from 'react-cookie';

import { PeriodReport } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

interface GetPeriodReports {
  slug: string;
  id: string;
}

export const getPeriodReports = async ({ slug, id }: GetPeriodReports) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/period_report/${slug}/${id}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as PeriodReport;
};
